<template>
<div>
    <div class="row">
        <div class="col-xs-12">
            <h4>{{ $_locale('players at tee time') }}</h4>
        </div>
        <div class="col-xs-12">
            <golf-player class="active"
                v-if="!adminMode && userPlayerValid && !userAlreadyLinked"
                :person="userPlayer" 
                :price="0">
            </golf-player>
            <template v-if="selectedPlayersTmpObjs.length > 0">
                <golf-player 
                    @select="removePlayer(player)"
                    ref="player-going"
                    v-for="player in selectedPlayersTmpObjs" 
                    :key="player.personId"
                    :person="player"
                    :price="playerPrice(player)"
                    :mode="'remove'">
                </golf-player>
            </template>
            <template v-if="linkedPlayers.length > 0">
                <golf-player class="no-action"
                    v-for="player in linkedPlayers" 
                    :key="player.personId"
                    :person="player">
                </golf-player>
            </template>
            <p v-if="adminMode && selectedPlayersTmpObjs.length === 0 && linkedPlayers.length === 0" style="color:#888;font-weight:bold;font-style: italic;">Ei yhtään pelaajaa lähdössä</p>
        </div>
    </div>
    <div class="row" style="margin-bottom: 7px;">
        <div class="col-xs-12">
            <button class="btn btn-sm pull-right"
                v-if="adminMode"
                @click="toggleActive('addvisitorplayer', true)"
            >{{ $_locale('add a player without a club') }}</button>
            <h4>{{ $_locale('add players to tee time') }}</h4>
        </div>
        <div class="col-xs-6" style="margin-bottom: 7px;padding-right: 7px;">
            <input class="form-control" 
                v-model="playerFirstName" 
                :placeholder="$_locale('first name')"
                @keyup.enter="findPlayer" />
        </div>
        <div class="col-xs-6" style="margin-bottom: 7px;padding-left: 0;">
            <input class="form-control" 
                v-model="playerFamilyName" 
                :placeholder="$_locale('last name')"
                @keyup.enter="findPlayer" />
        </div>
        <div class="col-xs-5" style="padding-right: 0;">
            <select class="form-control" v-model="playerClubId">
                <option :value="null">{{ $_locale('select club') }}</option>
                <option v-for="club in clubs" :key="club.clubId" :value="club.clubId">{{ club.name }}</option>
            </select>
        </div>
        <div class="col-xs-5" style="padding: 0 7px;">
            <input class="form-control" 
                v-model="playerNumber"
                :placeholder="$_locale('membership number')"
                @keyup.enter="findPlayer" />
        </div>
        <div class="col-xs-2" style="padding-left: 0;">
            <button class="btn btn-sm btn-default btn-block" @click="findPlayer">
                <i class="glyphicon"
                    :class="{
                        'glyphicon-search': !playerSearchActive,
                        'glyphicon-refresh': playerSearchActive,
                        'spin': playerSearchActive
                    }">
                </i>
                <span>{{ $_locale('search') }}</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <p v-if="playerSearchEmpty" style="color:#888;font-weight:bold;font-style: italic;">{{ searchComment }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <wn-pages :items="playerSearch" :perPage="6">
                <template v-slot="{ item: player }">
                    <golf-player :key="player.personId"
                        @select="selectPlayer(player)"
                        :ref="'player-available'"
                        :person="player"
                        :price="playerPrice(player)"
                        :mode="'add'">
                    </golf-player>
                </template>
            </wn-pages>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import GolfPlayer from './GolfPlayer.vue'

export default {
    components: {
        GolfPlayer
    },
    props: {
        toggleActive: {
            type: Function,
            required: true,
        },
        hidePlayers: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        namePublic: true,
        playerFirstName: '',
        playerFamilyName: '',
        playerClubId: '',
        playerNumber: '',
        selectedPlayersTmp: [],
        removedPlayersTmp: [],
        playerSearchActive: false,
        playerSearchEmpty: false,
    }),
    computed: {
        ...mapGetters({
            activeReservation: 'calendar/activeReservation',
            loggedIn: 'common/loggedIn',
            adminMode: 'common/adminMode',
            userPlayer: 'golf/userPlayer',
            clubs: 'golf/clubs',
            selectedPlayers: 'golf/selectedPlayers',
            availablePlayers: 'golf/players',
            isPlayerSelected: 'golf/isPlayerSelected',
            reservationPlayers: 'golf/reservationPlayers',
            allPlayers: 'golf/allPlayers',
            defaultClubId: 'golf/defaultClubId',
            allPlayerPrices: 'golf/allPlayerPrices',
        }),
        userPlayerValid() {
            return this.userPlayer.personId !== null;
        },
        availableSlots() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return 0;
            }
            const availableQuantity = this.activeReservation.block.availableQuantity + this.hidePlayers.length;
            const selectedPlayers = this.selectedPlayers.length;
            const reduction = this.adminMode 
                || (!this.adminMode && !this.userPlayerValid) 
                || (!this.adminMode && this.userAlreadyLinked) ? 0 : 1;
            const value = (availableQuantity - reduction) - selectedPlayers;
            
            return value;
        },
        playerPrice() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return (person = null) => 0;
            }
            
            const basePrice = this.activeReservation.block.price;

            return (person = null) => {
                if (person === null) return basePrice;

                const priceObj = this.allPlayerPrices.filter(row => row.personId === person.personId)[0];

                return !!priceObj ? priceObj.price : basePrice;
            };
        },
        linkedPlayers() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return [];
            }

            const reservations = this.activeReservation.block.reservations.map(
                row => row.reservationTimeId
            );

            return this.reservationPlayers.filter(
                row => reservations.indexOf(row.reservationTimeId) > -1 && this.hidePlayers.indexOf(row.reservationTimeId) === -1
            ).map(row => {
                const player = { ...row };
                const playerIsUser = player.personId === this.userPlayer.personId;
                
                if ((!this.loggedIn || !row.namePublic) && !playerIsUser) {
                    player.firstName = this.$_locale('reserved');
                    player.familyName = '';
                    player.clubAbbreviation = '';
                }

                return player;
            })
        },
        userAlreadyLinked() {
            return this.linkedPlayers.filter(row => row.personId === this.userPlayer.personId).length > 0
        },
        searchComment() {
            if (!this.playerSearchEmpty) {
                return '';
            }
            const firstname = this.playerFirstName.trim();
            const familyname = this.playerFamilyName.trim();
            const clubid = -(-this.playerClubId);
            const memberno = this.playerNumber.trim();
            const allFound = firstname.length > 0 && familyname.length > 0 && !!clubid && memberno.length > 0;

            if (allFound) {
                return _locale('the search didn\'t find any players').ucfirst();
            }

            return _locale('the search didn\'t find any players, try to be more specific').ucfirst();
        },
        removedPlayersTmpObjs() {
            return this.removedPlayersTmp.map(personId => 
                this.allPlayers.filter(row => row.personId === personId)[0]
            )
        },
        selectedPlayersTmpObjs() {
            const notInRemovedPlayersTmp = (row) => this.removedPlayersTmp.indexOf(row.personId) === -1;
            const selectedPlayers = this.selectedPlayers;
            const selectedPersonIds = selectedPlayers.map(row => row.personId);
            const availablePlayers = [
                ...selectedPlayers,
                ...this.selectedPlayersTmp
                .filter(personId => selectedPersonIds.indexOf(personId) === -1)
                .map(personId => 
                    this.allPlayers.filter(row => row.personId === personId)[0]
                )
            ]
            const selected = availablePlayers.filter(notInRemovedPlayersTmp);
            
            return selected;
        },
        playerSearch() {
            const linkedPersonIds = this.linkedPlayers.map(row => row.personId);
            const notInLinkedPlayers = (row) => linkedPersonIds.indexOf(row.personId) === -1;
            const notInSelectedPlayersTmp = (row) => this.selectedPlayersTmp.indexOf(row.personId) === -1;
            let availablePlayers = [
                ...this.availablePlayers,
                ...this.removedPlayersTmpObjs
            ];

            if (this.adminMode) {
                if (!this.isPlayerSelected(this.userPlayer)) {
                    availablePlayers.push(this.userPlayer);
                }
            }
            
            return availablePlayers
            .filter(notInLinkedPlayers)
            .filter(notInSelectedPlayersTmp)
            .filter((row) => {
                if (row.personId === null) {
                    return false;
                }

                let found = false;
                const memberNO = this.playerNumber.trim();
                const firstNameSearch = this.playerFirstName.trim().toLowerCase();
                const familyNameSearch = this.playerFamilyName.trim().toLowerCase();
                const firstName = row.firstName.toLowerCase();
                const familyName = row.familyName.toLowerCase();

                if (firstNameSearch.length > 0) {
                    if (firstName.indexOf(firstNameSearch) > -1) {
                        found = true;
                    } else {
                        return false;
                    }
                } else if (familyNameSearch.length > 0) {
                    if (familyName.indexOf(familyNameSearch) > -1) {
                        found = true;
                    } else {
                        return false;
                    }
                } else {
                    found = true;
                }

                if (memberNO.length > 0) {
                    if (memberNO == row.memberNO) {
                        found = true;
                    } else {
                        return false;
                    }
                }
                
                if (!!this.playerClubId) {
                    if (this.playerClubId == row.clubId) {
                        found = true;
                    } else {
                        return false;
                    }
                }
                
                return found;
            }).sort((a, b) => {
                const fullName_a = `${ a.familyName } ${ a.firstName }`;
                const fullName_b = `${ b.familyName } ${ b.firstName }`;

                if (fullName_a < fullName_b) {
                    return -1;
                }
                if (fullName_a > fullName_b) {
                    return 1;
                }
                return   0;
            })
        },
    },
    methods: {
        reset() {
            this.selectedPlayersTmp = [];
            this.removedPlayersTmp = [];
        },
        getPlayers() {
            return {
                added: this.selectedPlayersTmp,
                removed: this.removedPlayersTmp,
            }
        },
        resetPlayerFind(onlyPlayer = false) {
            if (!onlyPlayer) {
                this.playerClubId = this.defaultClubId;
            }
            
            this.playerFirstName = '';
            this.playerFamilyName = '';
            this.playerNumber = '';
        },
        removePlayer(player) {
            const foundSelected = this.selectedPlayers.filter(row => row.personId === player.personId)[0]

            if (!!foundSelected) {
                this.removedPlayersTmp.push(player.personId);
            } else {
                const foundSelectedTmpIndex = this.selectedPlayersTmp.indexOf(player.personId);

                this.selectedPlayersTmp.splice(foundSelectedTmpIndex, 1);
            }
        },
        selectPlayer(player) {
            const available = this.availableSlots + this.removedPlayersTmp.length - this.selectedPlayersTmp.length;
            
            if (available > 0) {
                const foundRemovedTmpIndex = this.removedPlayersTmp.indexOf(player.personId);

                if (foundRemovedTmpIndex > -1) {
                    this.removedPlayersTmp.splice(foundRemovedTmpIndex, 1);
                } else {
                    this.selectedPlayersTmp.push(player.personId);
                    this.resetPlayerFind(true);
                }
            } else {
                if (Array.isArray(this.$refs['player-going'])) {
                    this.$refs['player-going']
                        .forEach(element => {
                            element.shakeElement();
                        })
                } else {
                    const element = this.$refs['player-going']

                    element.shakeElement();
                }
            }
        },
        findPlayer() {
            const firstname = this.playerFirstName.trim();
            const familyname = this.playerFamilyName.trim();
            let clubid = -(-this.playerClubId);
            const memberno = this.playerNumber.trim();
            const allFound = firstname.length > 0 && familyname.length > 0 && !!clubid && memberno.length > 0;
            const memberNOAndClubId = !!clubid && memberno.length > 0;
            const nameAndClubId = firstname.length > 0 && familyname.length > 0 && !!clubid;
            const adminSearch = this.adminMode && firstname.length > 0 && familyname.length > 0;
            
            console.log({ firstname, familyname, clubid, memberno, allFound, memberNOAndClubId, nameAndClubId, adminSearch });
            
            if (this.adminMode) {
                if (clubid == 0) {
                    clubid = '';
                }
            } else {
                if (!nameAndClubId && !memberNOAndClubId) {
                    return false;
                }
            }
            
            this.playerSearchEmpty = false;
            this.playerSearchActive = true;
            this.$store.dispatch(
                'golf/getPlayerInformation', 
                {
                    memberno, 
                    clubid, 
                    firstname,
                    familyname,
                }
            ).then((response) => {
                const { data } = response;

                if (data.rows.length > 0) {
                    //this.resetPlayerFind();
                } else {
                    this.playerSearchEmpty = true;
                }

                this.playerSearchActive = false;
            })
        },
    },
    mounted() {
        this.resetPlayerFind();
    }
}
</script>